import {
  CACHE_KEYS,
  getFromCache,
  saveToCache,
  isCacheExpired,
  updateCacheTime,
  clearCacheAndTime,
  isSafariOrIOS,
} from '@/utils/CacheHelper'
import { useEndpoints } from '@/composables'
import { httpClient } from '@/services'

const STORE_NAME = CACHE_KEYS.STORE.VEHICLE_MODEL_WHEEL_DIAMETER_UNIT_CHOICES
const CACHE_TIME_KEY = CACHE_KEYS.TIME.VEHICLE_MODEL_WHEEL_DIAMETER_UNIT_CHOICES
const API_URL = useEndpoints.vehicleModel.choices.wheelDiameterUnitChoices()

// Store ongoing request promise
let inFlightRequest = null

export async function getAllVehicleModelWheelDiameterUnitChoicesData(
  cacheTime = CACHE_KEYS.EXPIRE_TIME.THREE_DAYS
) {
  // ----------------------------
  // SAFARI: ALWAYS FETCH FROM API (no IndexedDB)
  // ----------------------------
  if (isSafariOrIOS()) {
    // if a request is already in-flight, reuse it
    if (inFlightRequest) {
      return inFlightRequest
    }

    // arrow function (ESLint-safe)
    const fetchDirectFromApi = async () => {
      try {
        const res = await httpClient
          .get(API_URL)
          .then((r) => r)
          .catch((err) => {
            console.log('vehicle-model-wheel-diameter-unit-choices-fetch-err', {
              err,
            })
            return { data: [] }
          })
        const batch = res.data
        // DO NOT save to cache for Safari
        return batch
      } finally {
        // Clear in-flight request reference once complete
        inFlightRequest = null
      }
    }

    inFlightRequest = fetchDirectFromApi()
    return inFlightRequest
  }

  // ----------------------------
  // NON-SAFARI: original flow (cache-first)
  // ----------------------------

  // If cache is still valid → return it
  if (!isCacheExpired(CACHE_TIME_KEY, cacheTime)) {
    return await getFromCache(STORE_NAME)
  }

  // If request already in-flight → return the same promise
  if (inFlightRequest) {
    return inFlightRequest
  }

  // Clear cache before fetching fresh data
  await clearCacheAndTime(STORE_NAME, CACHE_TIME_KEY)

  async function fetchNextBatch() {
    const res = await httpClient
      .get(API_URL)
      .then((res) => res)
      .catch((err) => {
        console.log('vehicle-model-wheel-diameter-unit-choices-fetch-err', {
          err,
        })
        return { data: [] }
      })
      .finally(() => {
        // Clear in-flight request reference once complete
        inFlightRequest = null
      })
    const batch = res.data.map((item) => {
      return {
        ...item,
        id: crypto.randomUUID(),
      }
    })

    await saveToCache(STORE_NAME, batch)

    updateCacheTime(CACHE_TIME_KEY)
    return await getFromCache(STORE_NAME)
  }

  // Store the in-flight promise so others can await it
  inFlightRequest = fetchNextBatch()
  return inFlightRequest
}
